import qs from 'qs'

export const serializePersonsQueryParams = (
  params: Record<string, unknown>,
) => {
  const normalizedParams = Object.entries(params).reduce<
    Record<string, unknown>
  >((accumulator, [key, value]) => {
    if (!Array.isArray(value)) {
      accumulator[key] = value
      return accumulator
    }

    if (!value.length) {
      return accumulator
    }

    accumulator[key] =
      key === 'personIds' && value.length === 1 ? [value[0], value[0]] : value

    return accumulator
  }, {})

  return qs.stringify(normalizedParams, { arrayFormat: 'repeat' })
}
